(function($){

    $('.stream-application-form input[type=radio][name=role]').change(function () {
        if (this.value === 'Broker') {
            $("#clientFields").fadeIn();
        } else if (this.value === 'Principal') {
            $("#clientFields").fadeOut();
        }
    });

    $('form#stream-docpack-v2').submit(function () {

        var $thisForm        = $(this);
        var $responsemessage = $(this).find('#errorBoxWrap');

        $thisForm.find('#errorBoxWrap').removeClass('alert alert-danger alert-success').hide();

        $thisForm.find('button').attr('disabled',true)

        $.ajax({
            type: "POST",
            cache: false,
            dataType: 'json',
            url: $(this).attr('action'),
            data: $(this).serializeArray(),
            success: function(response) {

                $thisForm.find('button').attr('disabled',false);

                if (response.success){

                    //$responsemessage.addClass('alert alert-success').show().html(response.msg);

                    window.location.href = response.thank_you_url;

                    $thisForm.find('.email-field').val('');

                    $thisForm.find("input[type=text],input[type=email], textarea").val("");

                }else{

                    $responsemessage.addClass('alert alert-danger').show().html(response.msg);

                }

            },

            error: function(response) {

                $thisForm.find('button').attr('disabled',false);

                alert('ERROR: Please try again');
            }
        });

        return false;
    });

    $('.js-market-research-form').find('.privacy-notice')
        .before('<span class="privacy-notice__label">Privacy Notice</span>');

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
          isMobDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let $node = $('.js-pdf-frame'),
        url = $node.attr('data-url');

    if (isSafari && !isMobDevice) {
        let $frame = `<iframe width="100%" height="100%" src="${url}"></iframe>`;
        $node.html($frame);
    } else if (isSafari && isMobDevice) {
        $node.html(`
            Download : <a href="${url}">Confidentiality Agreement</a>
        `);
    } else {
        let $object = `<object data="${url}" type="application/pdf" width="100%" height="100%">
                        Download : <a href="${url}">Confidentiality Agreement</a>
                       </object>`;
        $node.html($object);
    }

})(jQuery);